import { Skeleton } from '@cast/design-system';

import { MetricRowsSkeleton, ProgressMetricSkeleton } from './FleetMetricTile';

const clustersTileLayoutReserve = {
  headerEnd: true,
  footerRows: 2,
} as const;

const nodesTileLayoutReserve = {
  footerRows: 3,
  middleHeight: 8,
} as const;

const utilizationTileLayoutReserve = {
  footerRows: 2,
  middleHeight: 56,
} as const;

export const clustersTileLoading = {
  layoutReserve: clustersTileLayoutReserve,
  headerEnd: (
    <Skeleton
      variant="rounded"
      width={86}
      height={24}
      sx={{ borderRadius: '999px' }}
    />
  ),
  valueWidth: 48,
  footer: <MetricRowsSkeleton rows={2} />,
} as const;

export const nodesTileLoading = {
  layoutReserve: nodesTileLayoutReserve,
  middle: <ProgressMetricSkeleton />,
  footer: <MetricRowsSkeleton rows={3} />,
  valueWidth: 96,
} as const;

export const utilizationTileLoading = {
  layoutReserve: utilizationTileLayoutReserve,
  hideValue: true,
  middle: <Skeleton variant="rounded" width="100%" height={56} />,
  footer: <MetricRowsSkeleton rows={2} />,
} as const;
